module.exports = __webpack_public_path__ + "img/sxm-logo-white.a202a13e.svg";